export default function calcTaxByCurrentAndRate(current: number, taxRate: number) {

  return (current - (current /((taxRate + 100) / 100)));
  //return Math.round((current * (taxRate / 100)) * 100) / 100;
}
